import { get } from 'lodash';

import { FIELD_PATHS, YES_NO_OPTIONS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { BrokerInterviewsGuarantorEntityIndex } from '@funnels/types';

import { FunnelGrid, FunnelGridUnit } from '../../../Common';
import { RadioButtonsField } from '../../../Fields';

export const MeetLoanRepayments = ({ brokerInterviewsGuarantorIndex }: BrokerInterviewsGuarantorEntityIndex) => {
  const [formValues] = useFormValues();

  return (
    <FunnelGrid mt="xs" mb="lg">
      <FunnelGridUnit size={1 / 2}>
        If you had to loan money to repay the guaranteed amount, would you still be in a position to meet the loan
        repayments from your income in addition to your reasonable living expenses?
      </FunnelGridUnit>
      <FunnelGridUnit size={1 / 2}>
        <RadioButtonsField
          name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_CONFIRM_COULD_MEET_LOAN_REPAYMENTS(
            brokerInterviewsGuarantorIndex
          )}
          radios={YES_NO_OPTIONS}
          size="sm"
          isBoxed={false}
          noVerticalSpace
          selectedValue={get(
            formValues,
            FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_CONFIRM_COULD_MEET_LOAN_REPAYMENTS(brokerInterviewsGuarantorIndex)
          )}
          isOptional
        />
      </FunnelGridUnit>
    </FunnelGrid>
  );
};
